export const IconSquareMenu = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M15 21q-.825 0-1.412-.587A1.93 1.93 0 0 1 13 19v-4q0-.825.588-1.412A1.93 1.93 0 0 1 15 13h4q.824 0 1.413.588Q21 14.175 21 15v4q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm0-10q-.825 0-1.412-.588A1.93 1.93 0 0 1 13 9V5q0-.824.588-1.412A1.93 1.93 0 0 1 15 3h4q.824 0 1.413.587Q21 4.176 21 5v4q0 .825-.587 1.412A1.93 1.93 0 0 1 19 11zM5 11q-.824 0-1.412-.588A1.93 1.93 0 0 1 3 9V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h4q.825 0 1.412.587Q11 4.176 11 5v4q0 .825-.588 1.412A1.93 1.93 0 0 1 9 11zm0 10q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19v-4q0-.825.587-1.412A1.93 1.93 0 0 1 5 13h4q.825 0 1.412.588Q11 14.175 11 15v4q0 .824-.588 1.413A1.93 1.93 0 0 1 9 21z" />
    </svg>
  );
};
